import { render, staticRenderFns } from "./payments-due.vue?vue&type=template&id=cfd60cd8"
import script from "./payments-due.vue?vue&type=script&lang=js"
export * from "./payments-due.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports